import ProductLicense from "interfaces/response/ProductLicense";

export const checkIfIsEnterpriseLicense = (license: ProductLicense) => {
  return (
    license &&
    license.isCustomizableLicense &&
    !license.isAutomaticPurchaseAllowed
  );
};
